module.exports = __webpack_public_path__ + "static/media/Материали и предложения за решения за извънредното заседание на ОСА на Формопласт АД, насрочено за 27.05.2024.f0573f46.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2024/Материали и предложения за решения за извънредното заседание на ОСА на Формопласт АД, насрочено за 27.05.2024.pdf
// module id = 93
// module chunks = 0